
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { t } from 'i18next';
import { useEffect } from 'react';
import { hasAuthParams, useAuth } from 'react-oidc-context';

export const Route = createFileRoute('/')({
    component: IndexPage,
})

function IndexPage() {

    const auth = useAuth();
    const navigate = useNavigate()

    useEffect(() => {
        if (
            !hasAuthParams() &&
            !auth.isAuthenticated &&
            !auth.activeNavigator &&
            !auth.isLoading
        ) {
            auth.signinRedirect();
        } else {
            navigate({ to: '/begin' });
        }
    }, [auth, navigate]);

    return (
        <div className="p-2">
            <h3>{t('label.index.welcomeAnonymous')}</h3>
        </div>
    )

}
